import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import FilterComponent from '@app/components/TableFilter/TableFilter';
import { PRCategoriesTable } from '@app/components/apps/PRCategories/PRCategoryTable';

const AllPRCategories: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-product-registration-category');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/product-registrations-categories',
            breadcrumbName: 'Product Registrations Categories',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Register Product',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Product Registration Categories</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PRCategoriesTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPRCategories;
